import { Stepper } from '@dreamtree-org/twreact-ui';

const STEPS = [
  { title: 'Cart', description: 'Review items' },
  { title: 'Address', description: 'Delivery details' },
  { title: 'Payment', description: 'Pay securely' },
  { title: 'Confirm', description: 'Order placed' },
];

/** The four-step checkout progress from mockup 04. */
export default function CheckoutSteps({ current }) {
  return (
    <div className="overflow-x-auto">
      <div className="min-w-[30rem]">
        <Stepper steps={STEPS} currentStep={current} orientation="horizontal" />
      </div>
    </div>
  );
}
